import { createAxiosClient } from "./axiosConfig";
import { jwtDecode } from "jwt-decode";

export const BASE_URL = "https://devg2iapi.sequspace.com/api";
export const SocketURL = "http://localhost:4001";

export function getCurrentAccessToken() {
  return localStorage.getItem("accessToken");
}

export function setCurrentAccessToken(accessToken: any) {
  return localStorage.setItem("accessToken", accessToken);
}
export function getCurrentRefreshToken() {
  return localStorage.getItem("refreshToken");
}

export function setCurrentRefreshToken(refreshToken: string) {
  localStorage.setItem("refreshToken", refreshToken);
}
export function isLoggedIn() {
  if (localStorage.getItem("accessToken")) {
    return true;
  } else {
    return false;
  }
}

export async function logout() {
  localStorage.clear();
  window.location.href = "/auth";
  return 0;
}


export const client = createAxiosClient({
  options: {
    baseURL: BASE_URL,
    timeout: 300000,
    headers: {},
  },
  getCurrentAccessToken,
});
